import CryptoJS from "crypto-js";

export function decrypt(ciphertext)
{
    let key = CryptoJS.enc.Hex.parse("9b1c8b2e4b9c3d2a5d6e7f8a9b0c1d2e3f4a5b6c7d8e9f0a1b2c3d4e5f6a7b8");
    let iv = CryptoJS.enc.Hex.parse("a1b2c3d4e5f6a7b8c9d0e1f2a3b4c5d6");

    let decrypted = CryptoJS.AES.decrypt(ciphertext, key, { iv: iv, mode: CryptoJS.mode.CTR, padding: CryptoJS.pad.NoPadding });
    return CryptoJS.enc.Utf8.stringify(decrypted);
}
